import { render, staticRenderFns } from "./DisplayDiscrepancy.vue?vue&type=template&id=6d46ed64&"
import script from "./DisplayDiscrepancy.vue?vue&type=script&lang=js&"
export * from "./DisplayDiscrepancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports